





































































































































import { SharedState } from "@/common/state";
import AppToggleBtn from "@/components/AppToggleBtn.vue";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import EventsModalVue from "@/components/modals/events-modal/EventsModal.vue";
import { EventsModalProps } from "@/components/modals/events-modal/model";
import { UseModal } from "@/components/root/modal";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { AxisType, CoordinateInputTier3, TimeAxisType } from "@/gql/types";
import { onMounted } from "@vue/composition-api";
import Vue from "vue";
import NotificationEmailModalVue from "../notification-email/NotificationEmailModal.vue";
import { PolicyL0StatusItem } from "./data/model";
import { state } from "./data/state";
import NotificationTemplateModalVue from "./NotificationTemplateModal.vue";
export default Vue.extend({
  props: ["has_feature"],
  components: { AppToggleBtn, DropDownSimple, SkeletonLoaderItem },
  setup() {
    const policy_options: Array<{ id: string; name: string }> = [
      { id: "high_severity", name: "on any high severity event" },
      {
        id: "external_high_severity",
        name:
          "on any high severity exposure to an <b>untrusted organization</b> or <b>personal contact</b>",
      },
      {
        id: "personal_address_high_severity",
        name:
          "on any high severity exposure to an <b>untrusted personal contact</b>",
      },
    ];

    const { status_list, is_loading, toggle_item_activity_state } = state;
    onMounted(async () => {
      SharedState.onReady(async () => {
        await state.init();
      });
    });

    const show_events_for_policy = async (item: PolicyL0StatusItem) => {
      let sentence = "";
      let insights: string[] = [];

      switch (item.policy_id) {
        case "high_severity":
          sentence = `<b>High severity events</b> which involved <b>${item.name}</b> information`;
          insights = SharedState.insights.value
            .filter(
              (f) =>
                f.type === "Compliance" &&
                f.infoTypeId === item.id &&
                f.severity === "High"
            )
            .map((d) => d.id);
          break;
        case "external_high_severity":
          sentence = `<b>High severity exposures</b> of <b>${item.name}</b> information to <b>untrusted organization</b> or <b>untrusted personal contact</b>`;
          insights = SharedState.insights.value
            .filter(
              (f) =>
                f.type === "Compliance" &&
                f.infoTypeId === item.id &&
                f.severity === "High" &&
                (f.shareType === "Shared to untrusted personal address" ||
                  f.shareType === "Shared to untrusted organization")
            )
            .map((d) => d.id);
          break;
        case "personal_address_high_severity":
        default:
          sentence = `<b>High severity exposures</b> of <b>${item.name}</b> information to <b>untrusted personal contact</b>`;
          insights = SharedState.insights.value
            .filter(
              (f) =>
                f.type === "Compliance" &&
                f.infoTypeId === item.id &&
                f.severity === "High" &&
                f.shareType === "Shared to untrusted personal address"
            )
            .map((d) => d.id);
          break;
      }
      const time_frame = SharedState.get_last_week_time_frame();
      await UseModal().show(EventsModalVue, {
        title: sentence,
        files_title: `<b>${item.name}</b> information files which were involved in high severity exposure events`,
        events_only: true,
        hide_all_filters: true,
        coordinates: [
          {
            x: {
              type: AxisType.None,
              values: [],
            },
            y: {
              type: AxisType.Insight,
              values: insights,
            },
            z: {
              type: TimeAxisType.Month,
              values: [time_frame.from],
            },
          },
        ] as CoordinateInputTier3[],
      } as EventsModalProps);
    };

    const show_email_template = async (item: PolicyL0StatusItem) => {
      await UseModal().show(NotificationEmailModalVue, {
        title: item.name,
        feature_id: "justification_automation",
        info_type: item.id,
      });
    };

    /*  const show_email_template = async (item: PolicyL0StatusItem) => {
      await UseModal().show(NotificationTemplateModalVue, {
        name: item.name,
      });
    }; */

    const change_policy_id = async (
      item: PolicyL0StatusItem,
      policy_id: string
    ) => {
      await state.update_policy(item.id, policy_id);
    };

    return {
      status_list,
      toggle_item_activity_state,
      show_events_for_policy,
      show_email_template,
      is_loading,
      policy_options,
      change_policy_id,
    };
  },
});
